import * as R from 'ramda'
import React, { useMemo } from 'react'
import { Message, MessageSender } from '@weblite/ts-action/message'
import { MessagePreviewMessageDescriptorTypography } from '$common/messsage-preview'
import { t } from '$i18n'
import { useSenderName } from '$logic/message/react-hook'

function SingleMessageDescription({ message }: { message: Message }) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { sender, body } = message
  const { name } = useSenderName(sender as MessageSender)
  return (
    <MessagePreviewMessageDescriptorTypography color="black">
      {body || t('forward.from')(name)}
    </MessagePreviewMessageDescriptorTypography>
  )
}
function MultiMessageDescription({ messages }: { messages: Message[] }) {
  const senderIds = useMemo(
    () =>
      R.uniqBy(
        R.prop('id'),
        messages.map(message => message.sender as MessageSender),
      ),
    [messages],
  )

  const { loading: firstSenderLoading, name: firstSender } = useSenderName(
    senderIds[0] as MessageSender,
  )
  const { loading: secondSenderLoading, name: secondSender } = useSenderName(
    senderIds[senderIds.length > 1 ? 1 : 0] as MessageSender,
  )
  if (firstSenderLoading || secondSenderLoading) return null
  return (
    <MessagePreviewMessageDescriptorTypography color="black">
      {senderIds.length === 1
        ? t('forward.from')(firstSender)
        : senderIds.length === 2
        ? t('forward.fromTwo')(firstSender, secondSender)
        : t('forward.fromSome')(firstSender, secondSender)}
    </MessagePreviewMessageDescriptorTypography>
  )
}

export function MessageDescriptor({ messages }: { messages: Message[] }) {
  if (messages.length === 1)
    return <SingleMessageDescription message={messages[0]} />

  return <MultiMessageDescription messages={messages} />
}
